import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import LazyImage from "~/js/common/lazy-image";
import Accordion from "~/js/common/accordion";
import Anchorlink from "~/js/common/anchorlink";
import Carousel from "~/js/common/carousel";
import StoreSearch from "~/js/store_search/store_detail";
import Selector from "~/js/common/selector";
import Modal from "~/js/common/modal";
import Tooltip from "~/js/common/tooltip";
export default class StoreSearchPage {
  constructor() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
      } else if (mutation.type === "init") {
        this.init();
      }
    });
    this.storeSearch = new StoreSearch();
    this.header = new Header();
    this.footer = new Footer();
    this.lazyImage = new LazyImage();
    this.carousel = new Carousel();
    this.accordion = new Accordion();
    this.anchorLink = new Anchorlink();
    this.selector = new Selector();
    this.modal = new Modal();
    new Tooltip();
    store.dispatch("init");
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
    Common.setupScrollY();
    Common.setupPageOptions();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new StoreSearchPage();
});